import { useFilterWithBackend } from "@/hooks/use-filter-with-backend";
import cn from "@/utils/class-names";
import { type Table as ReactTableType } from "@tanstack/react-table";
import { Box, Flex, Select, SelectOption, Text } from "rizzui";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import TablePagination from "../controlled-table/table-pagination";

const defaultOptions = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 20, label: "20" },
    { value: 25, label: "25" },
    { value: 35, label: "35" },
    { value: 50, label: "50" },
];

export default function TablePaginationPro<TData extends Record<string, any>>({
    table,
    showSelectedCount = false,
    className,
    options = defaultOptions,
}: {
    table: ReactTableType<TData>;
    showSelectedCount?: boolean;
    className?: string;
    options?: { value: number; label: string }[];
}) {
    const { state, applyFilter } = useFilterWithBackend<
        {
            page: string;
            size: string;
        },
        any
    >({
        page: table.getState().pagination.pageIndex.toString() ?? "0",
        size: table.getState().pagination.pageSize.toString() ?? "25",
    });

    return (
        <Flex
            gap="6"
            align="center"
            justify="between"
            className={cn("@container", className)}
        >
            <Flex align="center" className="w-auto shrink-0">
                <Text className="hidden font-normal text-gray-600 @md:block">
                    Rows per page
                </Text>
                <Select
                    size="sm"
                    variant="flat"
                    options={options}
                    className="w-12"
                    value={Number(state["size"])}
                    onChange={useDebouncedCallback((v: SelectOption) => {
                        // table.setPageSize(Number(v.value));
                        const size = Number(v.value);
                        applyFilter("size", size?.toString());

                        useDebounce(() => {
                            applyFilter("page", "0");
                        }, 100);
                    }, 500)}
                    suffixClassName="[&>svg]:size-3"
                    selectClassName="font-semibold text-xs ring-0 shadow-sm h-7"
                    optionClassName="font-medium text-xs px-2 justify-center"
                />
            </Flex>
            {showSelectedCount && (
                <Box className="hidden @2xl:block w-full">
                    <Text>
                        {table.getFilteredSelectedRowModel().rows.length} of{" "}
                        {table.getFilteredRowModel().rows.length} row(s)
                        selected.
                    </Text>
                </Box>
            )}
            <Flex justify="end" align="center">
                <TablePagination
                    paginatorClassName={""}
                    current={Number(state["page"]) + 1}
                    pageSize={table.getState().pagination.pageSize}
                    total={table.getRowCount()}
                    onChange={useDebouncedCallback(
                        (page: number, pageSize: number) => {
                            console.log("page", page, "pageSize", pageSize);

                            applyFilter("page", (page - 1)?.toString());
                        },
                        500,
                    )}
                />
                {/* <Text className="hidden font-normal text-gray-600 @3xl:block">
                    Page {Number(state["page"]) + 1} of{" "}
                    {table.getPageCount().toLocaleString()}
                </Text> */}
            </Flex>
        </Flex>
    );
}
